import {
    Component,
    effect,
    inject,
    input,
    resource,
    signal,
} from '@angular/core';
import { RichTextComponent } from '../../../common/rich-text/rich-text.component';
import { SharedNgxskeletonloaderModule } from '../../../../services/ngxskeletonloader.module';
import { ButtonComponent } from '../../../common/button/button.component';
import { firstValueFrom } from 'rxjs';
import { ApiService } from '../../../../services/api.service';
import { CheckoutService } from '../../../../services/checkout.service';
import { LanguageService } from '../../../../services/language.service';
import { Router, RouterLink } from '@angular/router';
import { CartService } from '../../../../services/cart.service';
import { DOMHandlerService } from '../../../../services/domhandler.service';
import { NgClass } from '@angular/common';
import { LightboxModule } from 'ng-gallery/lightbox';
import { Gallery } from 'ng-gallery';
import { BlogPost } from '../blog-post/blog-post.component';
import { Meta } from '@angular/platform-browser';
import { BlockNode } from '../../../../types/rich-text.types';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductService } from '../../../../services/product.service';

@Component({
    selector: 'app-full-blog-post',
    imports: [
        RichTextComponent,
        SharedNgxskeletonloaderModule,
        NgClass,
        LightboxModule,
        TranslatePipe,
        RouterLink,
        ButtonComponent,
    ],
    host: { class: 'container block mx-auto' },
    templateUrl: './full-blog-post.component.html',
})
export class FullBlogPostComponent {
    data = input.required<FullBlogPost>();
    apiService = inject(ApiService);
    checkoutService = inject(CheckoutService);
    languageService = inject(LanguageService);
    blogPostSlug = signal('');
    metaService = inject(Meta);
    blogPostResource = resource({
        request: () => ({
            slug: this.blogPostSlug(),
        }),
        loader: ({ request }) =>
            firstValueFrom(this.apiService.getBlogPostBySlug(request.slug)),
    });

    amount = signal<number>(1);
    productService = inject(ProductService);
    cartService: CartService = inject(CartService);
    domHandler: DOMHandlerService = inject(DOMHandlerService);
    showAddToCartAnimation = false;
    private router = inject(Router);

    constructor(private gallery: Gallery) {
        const galleryRef = this.gallery.ref('blog-post-gallery');
        galleryRef.setConfig({
            loop: true,
            thumbs: true,
        });

        effect(() => {
            if (
                this.blogPostResource.value() &&
                this.blogPostResource.value()!.data.length > 0
            ) {
                this.domHandler.addStructuredData(
                    this.getJsonLd(this.blogPostResource.value()!.data[0]),
                );
            }
        });
    }

    ngOnInit() {
        const url = this.router.url.split('/');
        if (url.length > 4) {
            this.blogPostSlug.set(url[4]);
        } else {
            this.blogPostSlug.set('');
        }
    }

    shareBlogPost(blogPost: BlogPost) {
        navigator.share({
            title: blogPost.title,
            url: window.location.href,
        });
    }

    private getJsonLd(blogPost: BlogPost) {
        return {
            '@context': 'https://schema.org',
            '@type': 'BlogPosting',
            headline: blogPost.title,
            url: window.location.href,
            mainEntityOfPage: window.location.href,
            image: blogPost.textImages[0].image.url,
            description: this.productService.getPreviewText(
                blogPost.textImages[0].text,
            ),
            articleBody: this.productService.getPreviewText(
                blogPost.textImages[0].text,
            ),
            author: {
                '@type': 'Person',
                name: 'Hof Zehentmoar',
            },
            datePublished: blogPost.createdAt,
            dateModified: blogPost.updatedAt,
        };
    }
}

type FullBlogPost = {
    infoText: BlockNode[];
};
